module.exports = __webpack_public_path__ + "img/level_five.522a95c6.png";